// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.

import _ from "lodash";
import React, { RefObject } from "react";
import { connect } from "react-redux";
//import { RouteComponentProps } from "react-router-dom";
import { RouteComponentProps, Link } from "react-router-dom";
import SplitPane from "react-split-pane";
import { bindActionCreators } from "redux";
import { PrimaryButton } from "@fluentui/react";
import HtmlFileReader from "../../../../common/htmlFileReader";
import { strings, interpolate } from "../../../../common/strings";
import {
    AssetState, AssetType, EditorMode, FieldType,
    IApplicationState, IAppSettings, IAsset, IAssetMetadata,
    ILabel, IProject, IRegion, ISize, ITag, FeatureCategory, FieldFormat,
    IAuthenticationState, IAzureFields
} from "../../../../models/applicationState";
import IApplicationActions, * as applicationActions from "../../../../redux/actions/applicationActions";
import IProjectActions, * as projectActions from "../../../../redux/actions/projectActions";
import IAppTitleActions, * as appTitleActions from "../../../../redux/actions/appTitleActions";
import { AssetPreview, ContentSource } from "../../common/assetPreviewFR/assetPreview";
import { KeyboardBinding } from "../../common/keyboardBinding/keyboardBinding";
import { KeyEventType } from "../../common/keyboardManager/keyboardManager";
import { TagInput } from "../../common/tagInputFR/tagInput";
import { tagIndexKeys } from "../../common/tagInputFR/tagIndexKeys";
import { TableView } from "../operations/tableView"
import CanvasHelpers from "../operations/canvasHelpers";
import "../operations/editorPage.scss";
import EditorSideBarN from "../operations/EditorSideBarN";
import Alert from "../../common/alert/alert";
import Confirm from "../../common/confirm/confirm";
import { OCRService } from "../../../../services/ocrService";
import { throttle } from "../../../../common/utils";
import { constants } from "../../../../common/constants";
import PreventLeaving from "../../common/preventLeaving/preventLeaving";
import { Spinner, SpinnerSize } from "@fluentui/react/lib/Spinner";
import { getPrimaryGreenTheme, getPrimaryRedTheme } from "../../../../common/themes";
import { toast } from "react-toastify";
import { PredictService } from "../../../../services/PredictService";
import { AssetService } from "../../../../services/assetService";
import BeforeUnloadComponent from "react-beforeunload-component";
import { SkipButton } from "../../shell/skipButton";
import ModalHeader from "../header/subHeader";
import ODModalHeader from "../header/ODsubHeader";
import HeaderComponent from "../header/header";
import size from "lodash/size";

import { StatusBar } from "../../shell/statusBar";
import { StatusBarMetrics } from "../../shell/statusBarMetrics";
import OperationsHeader from "../header/operationsSubHeader";
import IUserOperationsActions, * as userOperationsActions from "../../../../redux/actions/operationsActions";
import Canvas from "../operations/canvas_editTags";
import axios from "axios";
import { headers, invoiceManagentTagsSave } from "../../../../common/api-config";


/**
 * Properties for Editor Page
 * @member project - Project being edited
 * @member recentProjects - Array of projects recently viewed/edited
 * @member actions - Project actions
 * @member applicationActions - Application setting actions
 */
export interface IEditorPageFor_INVProps extends RouteComponentProps, React.Props<EditorPageFor_INV> {
    project: IProject;
    recentProjects: IProject[];
    appSettings: IAppSettings;
    actions: IProjectActions;
    applicationActions: IApplicationActions;
    appTitleActions: IAppTitleActions;
    loggedInUser: IAuthenticationState;
    loadAnnotateFiles: IAsset[];
    userOperationsActions: IUserOperationsActions;

}

/**
 * State for Editor Page
 */
export interface IEditorPageFor_INVState {
    /** Array of assets in project */
    assets: IAsset[];
    /** The editor mode to set for canvas tools */
    editorMode: EditorMode;
    /** The selected asset for the primary editing experience */
    selectedAsset?: IAssetMetadata;
    /** Currently selected region on current asset */
    selectedRegions?: IRegion[];
    /** Most recently selected tag */
    selectedTag: string;
    /** Tags locked for region labeling */
    lockedTags: string[];
    /** Size of the asset thumbnails to display in the side bar */
    thumbnailSize: ISize;
    /**
     * Whether or not the editor is in a valid state
     * State is invalid when a region has not been tagged
     */
    isValid: boolean;
    /** Whether the show invalid region warning alert should display */
    showInvalidRegionWarning: boolean;
    /** Show tags when loaded */
    tagsLoaded: boolean;
    /** The currently hovered TagInputItemLabel */
    hoveredLabel: ILabel;
    /** Whether the task for loading all OCRs is running */
    isRunningOCRs?: boolean;
    /** Whether OCR is running in the main canvas */
    isCanvasRunningOCR?: boolean;
    isCanvasRunningAutoLabeling?: boolean;
    isError?: boolean;
    errorTitle?: string;
    errorMessage?: string;
    tableToView: object;
    tableToViewId: string;
    selectedOcrFile: any;
    selectedProject: any;
    submitted: boolean;
    analyzeResult: any;

    userId: string;
    project: IProject;
    tagsInfo: any;
    iseTagSelected: boolean;
    eTagSelectedId: string;
    eTagSelectedVal: string;
    newTagValue: string;
    imageUrl:string;
    tableHeaders:any;
    sap_output:any;
    associationHeader:any;
    pr_in_headers:any;
    tagsShow:boolean;
}

function mapStateToProps(state: IApplicationState) {
    return {
        recentProjects: state.recentProjects,
        project: state.currentProject,
        appSettings: state.appSettings,
        loggedInUser: state.loggedInUser,
        loadAnnotateFiles: state.loadAllFiles,
    };
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(projectActions, dispatch),
        applicationActions: bindActionCreators(applicationActions, dispatch),
        appTitleActions: bindActionCreators(appTitleActions, dispatch),
        userOperationsActions: bindActionCreators(userOperationsActions, dispatch),

    };
}

/**
 * @name - Editor Page
 * @description - Page for adding/editing/removing tags to assets
 */
@connect(mapStateToProps, mapDispatchToProps)
export default class EditorPageFor_INV extends React.Component<IEditorPageFor_INVProps, IEditorPageFor_INVState> {
    public state: IEditorPageFor_INVState = {
        selectedTag: null,
        lockedTags: [],
        assets: [],
        editorMode: EditorMode.Select,
        thumbnailSize: { width: 175, height: 155 },
        isValid: true,
        showInvalidRegionWarning: false,
        tagsLoaded: false,
        hoveredLabel: null,
        tableToView: null,
        tableToViewId: null,
        selectedOcrFile: null,
        selectedProject: "",
        submitted: false,
        analyzeResult: null,
        userId: null,
        project: null,
        tagsInfo: [],
        iseTagSelected: false,
        eTagSelectedId: "",
        eTagSelectedVal: "",
        newTagValue: "",
        imageUrl:"",
        tableHeaders:[],
        sap_output:[],
        associationHeader:[],
        pr_in_headers:[],
        tagsShow:true,


    };

    private tagInputRef: RefObject<TagInput>;

    private loadingProjectAssets: boolean = false;
    private canvas: RefObject<Canvas> = React.createRef();
    private renameTagConfirm: React.RefObject<Confirm> = React.createRef();
    private renameCanceled: () => void;
    private deleteTagConfirm: React.RefObject<Confirm> = React.createRef();
    private deleteDocumentConfirm: React.RefObject<Confirm> = React.createRef();
    private isUnmount: boolean = false;
    private selectedInvalidFile: any;
    private path: any;
    selectedProject = ""
    private tag_folders = ['2630-9', 'certificateof-origin', "china-long-form-9295", "health-certificate", "Invalid", "invoice", "lab-results", "manifest-summary", "no-wood",
        "obl-hmm", "obl-hmm-1", "obl-oneobl", "ocean-bill-of-lading", "order-confirmation", "packing-list", "picture-of-cases", "picture-of-seal", "racto-letter"]


    constructor(props) { 
        super(props);
        this.tagInputRef = React.createRef();
        this.setState({ selectedProject: "", submitted: false });
        this.handleChange = this.handleChange.bind(this);
    }

    getPdfurl(){
        this.selectedInvalidFile = JSON.parse(localStorage.getItem("selectedFile"));
        let sap_output =  JSON.parse(this.selectedInvalidFile.sap_output.replace(/'/g, '"'))
        this.setState({sap_output:sap_output})
        console.log(sap_output['Pdf_url'])
        let Imageurl= sap_output['Pdf_url'] + "?sv=2019-10-10&ss=bfqt&srt=sco&sp=rwdlacupx&se=2030-07-13T23:43:36Z&st=2020-07-13T15:43:36Z&spr=https&sig=wfqsJ4ekq78VnUG07q45YLKjBbTaZUB3S%2F%2BmppSlX1g%3D";
        return Imageurl;
    }
    getFileName(){
        this.selectedInvalidFile = JSON.parse(localStorage.getItem("selectedFile"));
        return this.selectedInvalidFile['Filename']  }

    public async componentDidMount() { 
        window.addEventListener("focus", this.onFocused);
        this.isUnmount = false;
        const user = this.props.loggedInUser;
        const userId = user.user.oid;
        this.setState({ userId });
        this.selectedInvalidFile = JSON.parse(localStorage.getItem("selectedFile"));
        let sap_output =  JSON.parse(this.selectedInvalidFile.sap_output.replace(/'/g, '"'))
        console.log(sap_output['Pdf_url'])
        this.setState({sap_output:sap_output})
        let Imageurl= sap_output['Pdf_url'] + "?sv=2019-10-10&ss=bfqt&srt=sco&sp=rwdlacupx&se=2030-07-13T23:43:36Z&st=2020-07-13T15:43:36Z&spr=https&sig=wfqsJ4ekq78VnUG07q45YLKjBbTaZUB3S%2F%2BmppSlX1g%3D"
        let tagsKeyValues =[]
        for (const [key, value] of Object.entries(sap_output)) {
            if(key!= "PR_Association" && key!="Pdf_url" && key!='INV_Association' && key!='PurchaseReq'){
                tagsKeyValues.push({
                    key:key,
                    value:value
                })
            }
            
          }
          if(this.selectedInvalidFile.Type=='invoice_w_po_D'){
             
            let associationHeders = Object.keys(sap_output['INV_Association'][0])
            this.setState({associationHeader:associationHeders,pr_in_headers:sap_output['INV_Association']})
          }else{
            let associationHeders = Object.keys(sap_output['PR_Association'][0])
            this.setState({associationHeader:associationHeders,pr_in_headers:sap_output['PR_Association']})


          }
        const projectname = "invoice_w_po_D";
        const connection = { id: null, name: null, providerType: "azureBlobStorage", providerOptions: {} };
        connection.providerOptions["sas"] = IAzureFields.sasUrl;

        const project: IProject = {
            id: "",
            name: projectname,
            version: "",
            securityToken: "token",
            tags: [],
            sourceConnection: connection,
            lastVisitedAssetId: "",
            tableTags: [],
            fromModel: true,
            apiUriBase: IAzureFields.endPoint,
            apiKey: IAzureFields.key,
            folderPath: `${projectname}-${this.state.userId}}/training`,
            projType: "ocr", //model.type.toLocaleLowerCase(),
            assets: {},
            predictModelId: "",
            analyzeResult: [],
            exportFormat: null,
            activeLearningSettings: null,
            autoSave: false,
            targetConnection: null,
            videoSettings: null,
            isProjectExported: false,
            isProjectSaved: false,
        };
        this.setState({ project: project,tableHeaders:tagsKeyValues,  imageUrl:Imageurl});
        await this.loadProjectAssets();
        // this.getFilesFromBlob();
        document.title = strings.editorPage.title + " - " + strings.appName;
    }

    public getFilesFromBlob = () => {
        const projectCopy = Object.assign({}, this.state.project);
        projectCopy.folderPath = `${projectCopy.name}-${this.state.userId}/training`;
        this.props.actions.loadBlobs(projectCopy, "FailedProcess");
    }


    public async componentDidUpdate(prevProps: Readonly<IEditorPageFor_INVProps>, prevState) {
        if (this.props.project) {
            if (this.state.assets.length === 0) {
                await this.loadProjectAssets();
            } else {
                this.updateAssetsState();
            }
        }
        const { project } = this.props;
        if (this.props.loadAnnotateFiles !== prevProps.loadAnnotateFiles) {
            await this.loadProjectAssets();
        } else {
            localStorage.setItem("filesLengthFromModel", prevProps.loadAnnotateFiles.length.toString())
        }
      
    }

    public componentWillUnmount() {
        this.isUnmount = true;
        window.removeEventListener("focus", this.onFocused);
        this.abortController.abort();
    }

    //componentWillUnmount = () => this.abortController.abort();

    abortController = new window.AbortController();

    public render() {
        //const { project } = this.props;

        const project = this.state.project;
        const { assets, selectedAsset, isRunningOCRs, isCanvasRunningOCR, isCanvasRunningAutoLabeling, tagsInfo } = this.state;

        const labels = (selectedAsset &&
            selectedAsset.labelData &&
            selectedAsset.labelData.labels) || [];

        // console.log("selected asset==>"+JSON.stringify(selectedAsset));
        const needRunOCRButton = assets.some((asset) => asset.state === AssetState.NotVisited);

        // if (!project) {
        //     return (<div className="text-center mt-5">Loading...</div>);
        // }
        // else
        
            const routeUrl = `/upload-files/${this.props.match.params["projectName"]}/${this.props.match.params["schema"]}/ocr/${this.props.match.params["projectId"]}`;



            return (

                <>
                    <HeaderComponent
                        history={this.props.history}
                        match={this.props.match}
                        location={this.props.location} />

                    {/* <OperationsHeader propsMatch={this.props.match} /> */}
                    <div className="editor-page skipToMainContent" id="pageEditor">

                        <BeforeUnloadComponent
                            alertMessage='Are you sure you want to leave? Changes will not be saved.'
                        >

                            {this.state.tableToView !== null &&
                                <TableView
                                    handleTableViewClose={this.handleTableViewClose}
                                    tableToView={this.state.tableToView}
                                />
                            }
                            {
                                tagIndexKeys.map((index) =>
                                (<KeyboardBinding
                                    displayName={strings.editorPage.tags.hotKey.apply}
                                    key={index}
                                    keyEventType={KeyEventType.KeyDown}
                                    accelerators={[`${index}`]}
                                    icon={"fa-tag"}
                                    handler={this.handleTagHotKey} />))
                            }



                            <div className="editor-page-content" onClick={this.onPageClick}>
                                <SplitPane split="vertical"
                                    primary="second"
                                    maxSize={500}
                                    minSize={500}
                                    pane1Style={{ height: "100%", width: "50%" }}
                                    pane2Style={{ height: "auto", width: "50%" }}
                                    resizerStyle={{ width: "5px", margin: "0px", border: "2px", background: "transparent" }}
                                    onChange={() => this.resizeCanvas()}>
                                    <div className="editor-page-content-main" >
                                        {selectedAsset ?
                                            <div className="editor-page-content-main-body" onClick={this.onPageContainerClick}>
                                                {

                                                    selectedAsset &&
                                                    <Canvas
                                                        ref={this.canvas}
                                                        selectedAsset={this.state.selectedAsset}
                                                        onAssetMetadataChanged={this.onAssetMetadataChanged}
                                                        onCanvasRendered={this.onCanvasRendered}
                                                        onSelectedRegionsChanged={this.onSelectedRegionsChanged}
                                                        onRunningOCRStatusChanged={this.onCanvasRunningOCRStatusChanged}
                                                        onRunningAutoLabelingStatusChanged={this.onCanvasRunningAutoLabelingStatusChanged}
                                                        onTagChanged={this.onTagChanged}
                                                        onAssetDeleted={this.confirmDocumentDeleted}
                                                        editorMode={this.state.editorMode}
                                                        project={this.state.project}
                                                        lockedTags={this.state.lockedTags}
                                                        hoveredLabel={this.state.hoveredLabel}
                                                        setTableToView={this.setTableToView}
                                                        closeTableView={this.closeTableView}
                                                        runOcrForAllDocs={this.loadOcrForNotVisited}
                                                        appSettings={this.props.appSettings}
                                                    // selectedOcrFile={selectedOcrFile}
                                                    >
                                                        <AssetPreview
                                                            controlsEnabled={this.state.isValid}
                                                            onBeforeAssetChanged={this.onBeforeAssetSelected}
                                                            asset={this.state.selectedAsset.asset} />
                                                    </Canvas>
                                                }
                                            </div>
                                            : <Spinner
                                                size={SpinnerSize.large}
                                                label="Loading file to preview"
                                                ariaLive="off"
                                                className="mt-5"
                                                labelPosition="bottom"
                                            />
                                        }
                                    </div>
                                    <div >

                                        {
                                           this.state.tagsShow ?
                                                <div style={{}}>

                                                    {
                                                        this.tableDataShow()}
                                                </div>
                                                :
                                                <Spinner
                                                    size={SpinnerSize.small}
                                                    label="Loading Tags"
                                                    ariaLive="off"
                                                    labelPosition="bottom"
                                                />
                                        }
                                        <Confirm
                                            title={strings.editorPage.tags.rename.title}
                                            ref={this.renameTagConfirm}
                                            message={strings.editorPage.tags.rename.confirmation}
                                            confirmButtonTheme={getPrimaryRedTheme()}
                                            onCancel={this.onTagRenameCanceled}
                                            onConfirm={this.onTagRenamed}
                                        />
                                        <Confirm
                                            title={strings.editorPage.tags.delete.title}
                                            ref={this.deleteTagConfirm}
                                            message={strings.editorPage.tags.delete.confirmation}
                                            confirmButtonTheme={getPrimaryRedTheme()}
                                            onConfirm={this.onTagDeleted}
                                        />
                                        {this.state.selectedAsset &&
                                            <Confirm
                                                title={strings.editorPage.asset.delete.title}
                                                ref={this.deleteDocumentConfirm}
                                                message={
                                                    strings.editorPage.asset.delete.confirmation +
                                                    "\"" + this.state.selectedAsset.asset.name + "\"?"
                                                }
                                                confirmButtonTheme={getPrimaryRedTheme()}
                                                onConfirm={this.onAssetDeleted}
                                            />
                                        }
                                    </div>
                                </SplitPane>
                            </div>


                            <Alert
                                show={this.state.showInvalidRegionWarning}
                                title={strings.editorPage.messages.enforceTaggedRegions.title}
                                // tslint:disable-next-line:max-line-length
                                message={strings.editorPage.messages.enforceTaggedRegions.description}
                                onClose={() => this.setState({ showInvalidRegionWarning: false })}
                            />
                            <Alert
                                show={this.state.isError}
                                title={this.state.errorTitle || "Error"}
                                message={this.state.errorMessage}
                                onClose={() => this.setState({
                                    isError: false,
                                    errorTitle: undefined,
                                    errorMessage: undefined,
                                })}
                            />
                            <PreventLeaving
                                when={isRunningOCRs || isCanvasRunningOCR}
                                message={"An OCR operation is currently in progress, are you sure you want to leave?"}
                            />
                            <PreventLeaving
                                when={isCanvasRunningAutoLabeling}
                                message={"An AutoLabeling option is currently in progress, are you sure you want to leave?"} />

                            <SkipButton skipTo="pageEditor">{strings.common.skipToMainContent}</SkipButton>



                        </BeforeUnloadComponent>
                    </div>

                    <StatusBar>
                        <StatusBarMetrics project={this.props.project} />
                    </StatusBar>

                </>
            );
        


        //const { selectedOcrFile} = this.state;
        // const showTable = size(columnNames) > 0 ? true : false;

    }

    // call function from child
    private onPageContainerClick = () => {
        // workaround: tagInput will not lost focus with olmap,
        // so we fire the blur event manually here
        // this.tagInputRef.current.triggerNewTagBlur();
    }
    handleChange(event) {
        this.setState({ selectedProject: event.target.value });
        // this.selectedProject = event.target.value;
        console.log("@@@@@@@@@", this.selectedProject)

    }

    // tslint:disable-next-line:no-empty
    private onPageClick = () => {
    }

    public tableDataShow = () => {
        const { tagsInfo } = this.state;
        return (
            <div>
                <div className="card wrap-body-my_models shadow model-data mt-2">
                    <table className="table table-dark table-striped">
                        <thead>
                            <tr>
                                <th style={{width:'1000px'}}>Tag Name</th>
                                <th  style={{width:'5000px'}}>Tag Value</th>
                            </tr>
                        </thead>
                        <tbody>

                        {this.state.tableHeaders && this.state.tableHeaders.map((model, index) => {
                return (
                    <tr>
                        <td>{model.key =='Cust_Inv'?'Invoice No':model.key}</td>
                        <td> <input type="text" id="tag_val" name="tag_val" value={model.value} style={{ height: '34px', background: 'black', color: 'white', borderRadius: '2px', border: '1px', width:'100%' }}
                                       onChange={e => this.onChange(e, index)} /></td>
                    </tr>
                )})}

{/* {this.getFileName()=='2_Test_PR.pdf'?<tr>
                    <td> Requestor </td>
                    <td> <input type="text" id="tag_val" name="tag_val"  style={{ height: '34px', background: 'black', color: 'white', borderRadius: '2px', border: '1px', width:'100%' }}
                                        /></td> 
                    
                </tr>:''} */}
                {/* {this.getFileName()=='2_Test_PR.pdf'?<tr>
                    <td> Requestor Email </td>
                    <td> <input type="text" id="tag_val" name="tag_val"  style={{ height: '34px', background: 'black', color: 'white', borderRadius: '2px', border: '1px', width:'100%' }}
                                        /></td> 
                    
                </tr>:''} */}
                
              

                       

                        </tbody>

                    </table>
                     <br></br>


                     <table className="table table-dark table-striped">
                         <thead>
                             <tr>
                                 {this.state.associationHeader && this.state.associationHeader.map((element,index)=>{
                                  return ( 
                                      
                                      <th style={{width:'1000px'}}>
                                         {element == 'TargetQty' ? 'Quantity':element}
                                     </th>

                                  ) })
                                }
                                {/* {
                                    this.getFileName() == '2_Test_PR.pdf'? <th>
                                    Total 
                                 </th>:''
                                } */}
                             </tr>
                         </thead>
                         <tbody>

                        {this.state.pr_in_headers && this.state.pr_in_headers.map((model, index) => {
                return (
                    <tr>

                                 {this.state.associationHeader && this.state.associationHeader.map((element,index)=>{
                                  return (
                                      <td>
                                          {model[element]}
                                      </td> 
                                      
                                    // <td> <input type="text" id="tag_val" name="tag_val" value={model[element]} style={{ height: '34px', background: 'black', color: 'white', borderRadius: '2px', border: '1px', width:'100%' }}
                                    // onChange={e => this.AssociationChange(e, index)} /></td>

                                  ) })
                                }
                                {/* {
                                    this.getFileName() == '2_Test_PR.pdf'? <td>
                                    200 
                                 </td>:''
                                } */}
                               
                       
                        
                    </tr>
                )})}

                       

                        </tbody>
                     </table>



                    <div className="text-center mt-5" >
                        <button

                            onClick={() => this.back()}
                            className="btn-custom">
                            <i className="fa fa-code " aria-hidden="true"></i> Back
                                            </button> &nbsp;  <button 

onClick={() => this.submitReviewData()}
className="btn-custom">
<i className="fa fa-code " aria-hidden="true"></i> Submit
                </button>
                    </div>

                   
                   
                    <br>
                    </br>
                </div>

            </div>
        );
    }

    /**
     * Called when the asset side bar is resized
     * @param newWidth The new sidebar width
     */
    private onSideBarResize = (newWidth: number) => {
        this.setState({
            thumbnailSize: {
                width: newWidth,
                height: newWidth / (4 / 3),
            },
        });
        this.resizeCanvas()
    }




    private editTagData = async (data, index) => {
        const tagsInfo = [...this.state.tagsInfo];
        tagsInfo[index].isEditClicked = true;
        this.setState({ tagsInfo: tagsInfo, newTagValue: tagsInfo[index].tagValue });

    }



    private saveTagData = async (data, index) => {
        const tagsInfo = [...this.state.tagsInfo];
        tagsInfo[index].isUpdated = true;
        tagsInfo[index].isEditClicked = false;
        tagsInfo[index].tagValue = this.state.newTagValue;

        this.setState({ tagsInfo: tagsInfo, newTagValue: "" });

    }


    private cancelTagData = async (data, index) => {
        const tagsInfo = [...this.state.tagsInfo];
        tagsInfo[index].isUpdated = false;
        tagsInfo[index].isEditClicked = false;
        this.setState({ tagsInfo: tagsInfo });

    }

    private getInputValues = (event) => {

        if (event.target.value) {
            this.setState({ newTagValue: event.target.value });
        }
    }



    private submitReviewData = async () => {

        this.setState({tagsShow:false})
        console.log(this.state.sap_output)
        let object ={}
        this.state.tableHeaders.forEach(element=>{
             object[element.key] = element.value
        })
        object['Pdf_url'] = this.state.sap_output['Pdf_url']
if(this.selectedInvalidFile['Type'] == 'invoice_wo_po_D'){
    object['PR_Association'] = this.state.sap_output['PR_Association']
}else{
    object['INV_Association'] = this.state.sap_output['INV_Association']
}
    console.log(this.selectedInvalidFile)

        console.log(object)
       let body = {
        json_output:object
        }

        console.log(body)
        console.log("body",body)
        const endpointURL = invoiceManagentTagsSave(this.selectedInvalidFile.Filename);
        axios( endpointURL , { method: "POST" , data: body, headers}).
        then((resp) => {
          if (resp.status === 200 || resp.status === 201) {
            this.setState({tagsShow:true})

            toast.success("Tags Inspected & Updated Sucessfully", { position: toast.POSITION.TOP_CENTER });
          }
        })

    }






    /**
     * Called when the asset sidebar has been completed
     */
    private onSideBarResizeComplete = () => {
        const appSettings = {
            ...this.props.appSettings,
            thumbnailSize: this.state.thumbnailSize,
        };

        this.props.applicationActions.saveAppSettings(appSettings);
    }

    /**
     * Called when a tag from footer is clicked
     * @param tag Tag clicked
     */
    private onTagClicked = (tag: ITag): void => {
        this.setState({
            selectedTag: tag.name,
            lockedTags: [],
        }, () => this.canvas.current.applyTag(tag.name));
    }

    /**
     * Open confirm dialog for tag renaming
     */
    private confirmTagRename = (tag: ITag, newTag: ITag, cancelCallback: () => void): void => {
        this.renameCanceled = cancelCallback;
        this.renameTagConfirm.current.open(tag, newTag);
    }

    /**
     * Renames tag in assets and project, and saves files
     * @param tag Tag to be renamed
     * @param newTag Tag with the new name
     */
    private onTagRenamed = async (tag: ITag, newTag: ITag): Promise<void> => {
        this.renameCanceled = null;
        const assetUpdates = await this.props.actions.updateProjectTag(this.props.project, tag, newTag);
        const selectedAsset = assetUpdates.find((am) => am.asset.id === this.state.selectedAsset.asset.id);

        if (selectedAsset) {
            if (selectedAsset) {
                this.setState({ selectedAsset });
            }
        }
    }

    private onTagRenameCanceled = () => {
        if (this.renameCanceled) {
            this.renameCanceled();
            this.renameCanceled = null;
        }
    }

    /**
     * Open Confirm dialog for tag deletion
     */
    private confirmTagDeleted = (tagName: string): void => {
        this.deleteTagConfirm.current.open(tagName);
    }

    /**
     * Open Confirm dialog for document deletion
     */
    private confirmDocumentDeleted = (): void => {
        this.deleteDocumentConfirm.current.open();
    }

    /**
     * Removes tag from assets and projects and saves files
     * @param tagName Name of tag to be deleted
     */
    private onTagDeleted = async (tagName: string): Promise<void> => {
        const assetUpdates = await this.props.actions.deleteProjectTag(this.props.project, tagName);

        const selectedAsset = assetUpdates.find((am) => am.asset.id === this.state.selectedAsset.asset.id);
        if (selectedAsset) {
            this.setState({ selectedAsset });
        }
    }

    private onCtrlTagClicked = (tag: ITag): void => {
        const locked = this.state.lockedTags;
        this.setState({
            selectedTag: tag.name,
            lockedTags: CanvasHelpers.toggleTag(locked, tag.name),
        }, () => this.canvas.current.applyTag(tag.name));
    }

    private getTagFromKeyboardEvent = (event: KeyboardEvent): ITag => {
        const index = tagIndexKeys.indexOf(event.key);
        const tags = this.props.project.tags;
        if (index >= 0 && index < tags.length) {
            return tags[index];
        }
        return null;
    }

    /**
     * Listens for {number key} and calls `onTagClicked` with tag corresponding to that number
     * @param event KeyDown event
     */
    private handleTagHotKey = (event: KeyboardEvent): void => {
        const tag = this.getTagFromKeyboardEvent(event);
        const selection = this.canvas.current.getSelectedRegions();

        if (tag && selection.length) {
            const { format, type, documentCount, name } = tag;
            const tagCategory = this.tagInputRef.current.getTagCategory(tag.type);
            const category = selection[0].category;
            const labels = this.state.selectedAsset.labelData.labels;
            const isTagLabelTypeDrawnRegion = this.tagInputRef.current.labelAssignedDrawnRegion(labels, tag.name);
            const labelAssigned = this.tagInputRef.current.labelAssigned(labels, name);

            if (labelAssigned && ((category === FeatureCategory.DrawnRegion) !== isTagLabelTypeDrawnRegion)) {
                if (isTagLabelTypeDrawnRegion) {
                    toast.warn(interpolate(strings.tags.warnings.notCompatibleWithDrawnRegionTag, { otherCatagory: category }));
                } else if (tagCategory === FeatureCategory.Checkbox) {
                    toast.warn(interpolate(strings.tags.warnings.notCompatibleWithDrawnRegionTag, { otherCatagory: FeatureCategory.Checkbox }));
                } else {
                    toast.warn(interpolate(strings.tags.warnings.notCompatibleWithDrawnRegionTag, { otherCatagory: FeatureCategory.Text }));
                }
                return;
            } else if (tagCategory === category || category === FeatureCategory.DrawnRegion ||
                (documentCount === 0 && type === FieldType.String && format === FieldFormat.NotSpecified)) {
                if (tagCategory === FeatureCategory.Checkbox && labelAssigned) {
                    toast.warn(strings.tags.warnings.checkboxPerTagLimit);
                    return;
                }
                this.onTagClicked(tag);
            } else {
                toast.warn(strings.tags.warnings.notCompatibleTagType, { autoClose: 7000 });
            }
        }
        // do nothing if region was not selected
    }

    /**
     * Returns a value indicating whether the current asset is taggable
     */
    private isTaggableAssetType = (asset: IAsset): boolean => {
        return asset.type !== AssetType.Unknown;
    }

    /**
     * Raised when the selected asset has been changed.
     * This can either be a parent or child asset
     */
    private onAssetMetadataChanged = async (assetMetadata: IAssetMetadata): Promise<void> => {
        // Comment out below code as we allow regions without tags, it would make labeler's work easier.

        const initialState = assetMetadata.asset.state;

        const asset = { ...assetMetadata.asset };

        if (this.isTaggableAssetType(assetMetadata.asset)) {
            assetMetadata.asset.state = _.get(assetMetadata, "labelData.labels.length", 0) > 0 ?
                AssetState.Tagged :
                AssetState.Visited;
        } else if (assetMetadata.asset.state === AssetState.NotVisited) {
            assetMetadata.asset.state = AssetState.Visited;
        }

        // Only update asset metadata if state changes or is different
        if (initialState !== assetMetadata.asset.state || this.state.selectedAsset !== assetMetadata) {
            if (this.state.selectedAsset.labelData && this.state.selectedAsset.labelData.labels &&
                assetMetadata.labelData && assetMetadata.labelData.labels &&
                assetMetadata.labelData.labels.toString() !== this.state.selectedAsset.labelData.labels.toString()) {
                await this.updatedAssetMetadata(assetMetadata);
            }
            await this.props.actions.saveAssetMetadata(this.state.project, assetMetadata);
            if (this.state.project.lastVisitedAssetId === assetMetadata.asset.id) {
                this.setState({ selectedAsset: assetMetadata });
            }
        }

        // Find and update the root asset in the internal state
        // This forces the root assets that are displayed in the sidebar to
        // accurately show their correct state (not-visited, visited or tagged)
        const assets = [...this.state.assets];
        const assetIndex = assets.findIndex((a) => a.id === asset.id);
        if (assetIndex > -1) {
            assets[assetIndex] = {
                ...asset,
            };
        }

        this.setState({ assets, isValid: true });

        // Workaround for if component is unmounted
        if (!this.isUnmount) {
            this.props.appTitleActions.setTitle(`${this.state.project.name} - [ ${asset.name} ]`);
        }
    }

    private onAssetLoaded = (asset: IAsset, contentSource: ContentSource) => {
        const assets = [...this.state.assets];
        const assetIndex = assets.findIndex((item) => item.id === asset.id);
        if (assetIndex > -1) {
            const assets = [...this.state.assets];
            const item = { ...assets[assetIndex] };
            item.cachedImage = (contentSource as HTMLImageElement).src;
            assets[assetIndex] = item;
            this.setState({ assets });
        }
    }

    /**
     * Raised when the asset binary has been painted onto the canvas tools rendering canvas
     */
    private onCanvasRendered = async (canvas: HTMLCanvasElement) => {
        // When active learning auto-detect is enabled
        // run predictions when asset changes
    }

    private onSelectedRegionsChanged = (selectedRegions: IRegion[]) => {
        this.setState({ selectedRegions });
    }

    private onTagsChanged = async (tags) => {
        const project = {
            ...this.props.project,
            tags,
        };
        await this.props.actions.saveProject(project, true, false);
    }

    private onLockedTagsChanged = (lockedTags: string[]) => {
        this.setState({ lockedTags });
    }

    private onBeforeAssetSelected = (): boolean => {
        if (!this.state.isValid) {
            this.setState({ showInvalidRegionWarning: true });
        }


        return this.state.isValid;
    }

    private selectAsset = async (asset: IAsset): Promise<void> => {
        // Nothing to do if we are already on the same asset.
        if (this.state.selectedAsset && this.state.selectedAsset.asset.id === asset.id) {
            return;
        }

        if (!this.state.isValid) {
            this.setState({ showInvalidRegionWarning: true });
            return;
        }
        if (this.state.isCanvasRunningAutoLabeling) {
            return;
        }

        //

        const projectname = "invoice_w_po_D";
        const connection = { id: null, name: null, providerType: "azureBlobStorage", providerOptions: {} };
        connection.providerOptions["sas"] = IAzureFields.sasUrl;

        const project: IProject = {
            id: "",
            name: projectname,
            version: "",
            securityToken: "token",
            tags: [],
            sourceConnection: connection,
            lastVisitedAssetId: "",
            tableTags: [],
            fromModel: true,
            apiUriBase: IAzureFields.endPoint,
            apiKey: IAzureFields.key,
            folderPath: `${projectname}-${this.state.userId}}/training`,
            projType: "ocr", //model.type.toLocaleLowerCase(),
            assets: {},
            predictModelId: "",
            analyzeResult: [],
            exportFormat: null,
            activeLearningSettings: null,
            autoSave: false,
            targetConnection: null,
            videoSettings: null,
            isProjectExported: false,
            isProjectSaved: false,
        };
        //
        const assetMetadata = await this.props.actions.loadAssetMetadata(project, asset);
        // const assetMetadata = await this.props.actions.loadAssetMetadata(this.props.project, asset);
        //console.log("metadata==>"+JSON.stringify(assetMetadata));

        if (assetMetadata.labelData) {
            const alllabels = assetMetadata.labelData.labels;
            const tagsInfo = [];
            alllabels.forEach(async (element: any) => {
                const labelname = element.label;
                const labelval = element.value[0].text;
                const tagData = {
                    tagName: labelname,
                    tagValue: labelval,
                    isUpdated: false,
                    isEditClicked: false,

                }
                tagsInfo.push(tagData);

            });
            this.setState({ tagsInfo: tagsInfo });

        }
        try {
            if (!assetMetadata.asset.size) {
                const assetProps = await HtmlFileReader.readAssetAttributes(asset);
                assetMetadata.asset.size = { width: assetProps.width, height: assetProps.height };
            }
        } catch (err) {
            console.warn("Error computing asset size");
        }

        this.setState({
            selectedOcrFile: null,
            tableToView: null,
            tableToViewId: null,
            selectedAsset: assetMetadata,
        }, async () => {
            // await this.onAssetMetadataChanged(assetMetadata);
            //  await this.props.actions.saveProject(this.props.project, false, false);
        });
    }

    onChange =(event, index) =>{ 
        console.log(event.target)
        const { key, value } = event.target;
        this.setState(previousState => {
          const tableHeaders = [...previousState.tableHeaders];
          tableHeaders[index] = { ...tableHeaders[index],value:value};
          return { tableHeaders };
        });
      };

      AssociationChange =(event, index) =>{ 
        console.log(event.target)
        this.setState(previousState => {
          const pr_in_headers = [...previousState.pr_in_headers];
          pr_in_headers[index] = { ...pr_in_headers[index]};
          return { pr_in_headers };
        });
      };
    back(){
        this.props.history.push(`/invoiceManagement`);
    }

    private loadProjectAssets_fr = async (): Promise<void> => {
        //debugger;
        if (this.loadingProjectAssets) {
            return;
        }

        this.loadingProjectAssets = true;

        try {

            // new changes start
            const projectCopy = Object.assign({}, this.props.project);
            projectCopy.folderPath = `${this.props.match.params["projectName"]}-${this.state.userId}/training`;
            await this.props.actions.saveProject(projectCopy, false, false);


            const assets = _(await this.props.actions.loadAssets(this.props.project))
                .uniqBy((asset) => asset.id)
                .value();

            // new changes end

            //  const assets = _(await this.props.actions.loadAssets(this.props.project))
            //     .uniqBy((asset) => asset.id)
            //    .value();


            if (this.state.assets.length === assets.length
                && JSON.stringify(this.state.assets) === JSON.stringify(assets)) {
                this.loadingProjectAssets = false;
                this.setState({ tagsLoaded: true });
                return;
            }

            const lastVisited = assets.find((asset) => asset.id === this.props.project.lastVisitedAssetId);

            this.setState({
                assets,
            }, async () => {
                await this.props.actions.saveProject(this.props.project, false, true);
                this.setState({ tagsLoaded: true });
                if (assets.length > 0) {
                    await this.selectAsset(lastVisited ? lastVisited : assets[0]);
                }
                this.loadingProjectAssets = false;
            });
        } catch (error) {
            throw Error(error);
        }
    }


    private loadProjectAssets = async (): Promise<void> => { 
        this.loadingProjectAssets = true;
        const rootAssets =[{
            format: "pdf",
id: "2e1d92d5d41a36362bf1fa9b3718166d1d12f24ef3026db8d55d4499872db16f",
labelData: null,
labelFilename: "invoice_w_po_D-2541c8e9-3e3e-418a-9e21-818657238210/training/APInvoice-SAP51065578142010-InvINV033935.pdf.labels.json",
name: "invoice_w_po_D-2541c8e9-3e3e-418a-9e21-818657238210/training/APInvoice-SAP51065578142010-InvINV033935.pdf",
ocrContent:{},
path:this.getPdfurl(),
size: null,
state: 2,
type: 5
        }]
        this.setState({
            assets: rootAssets,
        });
        if (rootAssets.length > 0) {
            await this.selectAsset(rootAssets[0]);
        }
        this.loadingProjectAssets = false;
    }
    private isBusy = (): boolean => {
        return this.state.isRunningOCRs || this.state.isCanvasRunningOCR || this.state.isCanvasRunningAutoLabeling;
    }
    public loadOcrForNotVisited = async (runForAll?: boolean) => {
        if (this.isBusy()) {
            return;
        }
        const { project } = this.props;
        const ocrService = new OCRService(project);
        if (this.state.assets) {
            this.setState({ isRunningOCRs: true });
            try {
                await throttle(
                    constants.maxConcurrentServiceRequests,
                    this.state.assets
                        .filter((asset) => runForAll ? asset : asset.state === AssetState.NotVisited)
                        .map((asset) => asset.id),
                    async (assetId) => {
                        // Get the latest version of asset.
                        const asset = this.state.assets.find((asset) => asset.id === assetId);
                        if (asset && (asset.state === AssetState.NotVisited || runForAll)) {
                            try {
                                this.updateAssetState(asset.id, true);
                                await ocrService.getRecognizedTextFR(asset.path, asset.name, undefined, runForAll);
                                //await ocrService.getRecognizedText(asset.path, asset.name, undefined, runForAll);
                                this.updateAssetState(asset.id, false, AssetState.Visited);
                            } catch (err) {
                                this.updateAssetState(asset.id, false);
                                this.setState({
                                    isError: true,
                                    errorTitle: err.title,
                                    errorMessage: err.message,
                                });
                            }
                        }
                    }
                );
            } finally {
                this.setState({ isRunningOCRs: false });
            }
        }
    }

    private updateAssetState = (id: string, isRunningOCR: boolean, assetState?: AssetState) => {
        this.setState((state) => ({
            assets: state.assets.map((asset) => {
                if (asset.id === id) {
                    const updatedAsset = { ...asset, isRunningOCR };
                    if (assetState !== undefined && asset.state === AssetState.NotVisited) {
                        updatedAsset.state = assetState;
                    }
                    return updatedAsset;
                } else {
                    return asset;
                }
            }),
        }), () => {
            if (this.state.selectedAsset && id === this.state.selectedAsset.asset.id) {
                const asset = this.state.assets.find((asset) => asset.id === id);
                if (asset) {
                    this.setState({
                        selectedAsset: { ...this.state.selectedAsset, asset: { ...asset } },
                    });
                }
            }
        });
    }

    /**
     * Updates the root asset list from the project assets
     */
    private updateAssetsState = () => {
        const updatedAssets = [...this.state.assets];
        let needUpdate = false;
        updatedAssets.forEach((asset) => {
            const projectAsset = _.get(this.props, "project.assets[asset.id]", null);
            if (projectAsset) {
                if (asset.state !== projectAsset.state) {
                    needUpdate = true;
                    asset.state = projectAsset.state;
                }
            }
        });

        if (needUpdate) {
            this.setState({ assets: updatedAssets });
        }
    }

    private onLabelEnter = (label: ILabel) => {
        this.setState({ hoveredLabel: label });
    }

    private onLabelLeave = (label: ILabel) => {
        this.setState({ hoveredLabel: null });
    }

    private onCanvasRunningOCRStatusChanged = (isCanvasRunningOCR: boolean) => {
        this.setState({ isCanvasRunningOCR });
    }
    private onCanvasRunningAutoLabelingStatusChanged = (isCanvasRunningAutoLabeling: boolean) => {
        this.setState({ isCanvasRunningAutoLabeling });
    }
    private onFocused = () => {
        this.loadProjectAssets();
    }

    private onAssetDeleted = () => {
        this.props.actions.deleteAssetFR(this.props.project, this.state.selectedAsset).then(() => {
            this.loadProjectAssets();
        });
    }

    private onTagChanged = async (oldTag: ITag, newTag: ITag) => {
        const assetUpdates = await this.props.actions.updateProjectTag(this.props.project, oldTag, newTag);
        const selectedAsset = assetUpdates.find((am) => am.asset.id === this.state.selectedAsset.asset.id);

        if (selectedAsset) {
            this.setState({
                selectedAsset,
            });
        }
    }

    private setTableToView = async (tableToView, tableToViewId) => {
        if (this.state.tableToViewId) {
            this.canvas.current.setTableState(this.state.tableToViewId, "rest");
        }
        this.canvas.current.setTableState(tableToViewId, "selected");
        this.setState({
            tableToView,
            tableToViewId,
        });
    }

    private handleTableViewClose = () => {
        this.closeTableView("rest");
    }

    private closeTableView = (state: string) => {
        if (this.state.tableToView) {
            this.canvas.current.setTableState(this.state.tableToViewId, state);
            this.setState({
                tableToView: null,
                tableToViewId: null,
            });
        }
    }

    private resizeCanvas = () => {
        if (this.canvas.current) {
            this.canvas.current.updateSize();
        }
    }

    private async updatedAssetMetadata(assetMetadata: IAssetMetadata) {
        const assetDocumentCountDifference = {};
        const updatedAssetLabels = {};
        const currentAssetLabels = {};
        assetMetadata.labelData.labels.forEach((label) => {
            updatedAssetLabels[label.label] = true;
        });
        this.state.selectedAsset.labelData.labels.forEach((label) => {
            currentAssetLabels[label.label] = true;
        });
        Object.keys(currentAssetLabels).forEach((label) => {
            if (!updatedAssetLabels[label]) {
                assetDocumentCountDifference[label] = -1;
            }
        });
        Object.keys(updatedAssetLabels).forEach((label) => {
            if (!currentAssetLabels[label]) {
                assetDocumentCountDifference[label] = 1;
            }
        });
        await this.props.actions.updatedAssetMetadata(this.props.project, assetDocumentCountDifference);
    }
}
